import Phaser from 'phaser';
import { payFees } from '../../../web3/PaymentUtils';
import { getTeamId, payGameFee } from '../../../web3/SFM-TeamsUtils';

import { toast } from 'react-hot-toast';
export class PayFeesScene2 extends Phaser.Scene {
    constructor() {
        super({ key: 'PayFeesScene2' });
    }

    init(data) {
        // Access the mode parameter passed from Scene 1
        this.mode = data.mode;
    }

    create() {
        const x = 0; // X-coordinate of the center of the scene
        const y = (this.game.config.height / 2) + 5; // Y-coordinate of the center of the scene
        const outerDivElement = document.createElement('div');
        outerDivElement.classList.add('d-flex', 'justify-content-center', 'pt-5', 'pb-5', 'mt-5', 'game-container');
        const divElement = document.createElement('div');
        divElement.classList.add('payfees-container'); // Apply the CSS class to the div element
        // Replace with your desired boolean value
        const imgElement = document.createElement('img');
        imgElement.src = 'assets/img/game/PayGasFees2gif.gif';
        imgElement.alt = 'Pay Fees';
        divElement.appendChild(imgElement);
        const iElement = document.createElement('i');
        iElement.classList.add('fas', 'fa-arrow-left');
        iElement.addEventListener('click', this.backFromPaying);
        divElement.appendChild(iElement);
        outerDivElement.appendChild(divElement);
        this.add.dom(x, y, outerDivElement);
        this.startGameHandler()
    }

    backFromPaying() {
        // Define the logic for going back from paying
        window.location.reload();
    }

    async startGameHandler() {
        if (this.mode === "off") {
            try {
                await payFees();
                this.scene.start('SceneMainMenu', { mode: this.mode })
            } catch (error) {
                toast.error(`Payment Cancelled`);
            }
        } else if (this.mode === "on") {
            try {
                const teamIdObj = await getTeamId();
                const teamId = parseInt(teamIdObj._hex, 16);
                await payGameFee(teamId.toString(), "0.001");
                this.scene.start('SceneMainMenu', { mode: this.mode });
            } catch (error) {
                toast.error(`Payment Cancelled`);
            }
        }
    }
}